export default __webpack_public_path__ + "static/media/crypto-arbitrage.9c761f90.svg";